import React, { useState } from 'react';
import styles from './Gallery.module.css';
interface ImageObject {
    url: string;
    alt?: string;
    caption?: string;
}
interface GalleryProps {
    images: ImageObject[];
}
const Gallery: React.FC<GalleryProps> = ({ images }) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const handlePrevImage = () => {
        setCurrentImageIndex(prev => (prev > 0 ? prev - 1 : images.length - 1));
    };
    const handleNextImage = () => {
        setCurrentImageIndex(prev => (prev < images.length - 1 ? prev + 1 : 0));
    };
    if (images.length === 0) return null;
    const currentImage = images[currentImageIndex];
    return (
        <div className={styles.gallery}>
            <div className={styles.mainImageContainer}>
                <img
                    src={currentImage.url}
                    alt={currentImage.alt || `Изображение ${currentImageIndex + 1}`}
                    className={styles.mainImage}
                />
                {images.length > 1 && (
                    <>
                        <button
                            className={`${styles.navButton} ${styles.prevButton}`}
                            onClick={handlePrevImage}
                        >
                            &lt;
                        </button>
                        <button
                            className={`${styles.navButton} ${styles.nextButton}`}
                            onClick={handleNextImage}
                        >
                            &gt;
                        </button>
                    </>
                )}
                {currentImage.caption && (
                    <div className={styles.caption}>
                        {currentImage.caption}
                    </div>
                )}
            </div>
            {images.length > 1 && (
                <div className={styles.thumbnails}>
                    {images.map((img, index) => (
                        <div
                            key={index}
                            className={`${styles.thumbnailContainer} ${index === currentImageIndex ? styles.active : ''}`}
                            onClick={() => setCurrentImageIndex(index)}
                        >
                            <img
                                src={img.url}
                                alt={`Миниатюра ${index + 1}`}
                                className={styles.thumbnail}
                            />
                            {img.caption && (
                                <div className={styles.thumbnailCaption}>
                                    {img.caption}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
export default Gallery;